const translation = {
  // Nav
  nav_home: "Начало",
  nav_contracts: "Договори",
  nav_calculator: "Калкулатор",
  nav_analysts: "Анализатори",
  nav_benefits: "Предимства",
  nav_about: "За нас",
  nav_contact: "Контакт",

  // Hero
  hero_badge: "СПЕШНА ВЪЗМОЖНОСТ",
  hero_title1: "ИРАНСКАТА КРИЗА",
  hero_title2: "ВАШИЯТ ШАНС",
  hero_title3: "ЗА ПЕЧАЛБА",
  hero_subtitle: "20% от световния петрол е блокиран. Цените на Brent се покачват. Действайте сега.",
  hero_cta1: "ВИЖТЕ ДОГОВОРИТЕ",
  hero_cta2: "Научете повече",

  // Contracts
  contracts_title: "ИЗБЕРЕТЕ ВАШИЯ ДОГОВОР",
  contracts_subtitle: "Три нива на инвестиции с гарантирана доходност",
  contract_basic: "БАЗОВ",
  contract_popular: "НАЙ-ПОПУЛЯРЕН",
  contract_pro: "ПРОФЕСИОНАЛЕН",
  contract_investment: "Инвестиция",
  contract_profit: "ВАШАТА ПЕЧАЛБА",
  contract_total: "ОБЩО ЩЕ ПОЛУЧИТЕ",
  contract_yield: "ДОХОДНОСТ",
  contract_start: "ЗАПОЧНЕТЕ",
  contract_choose: "ИЗБЕРЕТЕ СЕГА",
  contract_maximize: "МАКСИМИЗИРАЙТЕ",
  contract_disclaimer: "* Доходността се основава на текущите пазарни условия и исторически данни. Инвестициите носят риск.",

  // Calculator
  calc_title: "КАЛКУЛАТОР НА ПЕЧАЛБАТА",
  calc_subtitle: "Вижте колко можете да спечелите с всеки договор",
  calc_investment: "Вашата инвестиция:",
  calc_yield: "Доходност:",
  calc_profit: "Вашата печалба:",
  calc_total: "Общо ще получите:",
  calc_basic_label: "Базово ниво",
  calc_popular_label: "Популярен избор",
  calc_max_label: "Максимална печалба",
  calc_double: "Удвоявате парите си!",
  calc_2_5: "Получавате 2.5 пъти повече!",
  calc_3x: "Получавате над 3 пъти повече!",
  calc_best: "НАЙ-ДОБРА ОФЕРТА",
  calc_cta_title: "Колкото повече инвестирате, толкова повече печелите!",
  calc_cta_sub: "Нашите договори са разработени за максимизиране на вашата печалба в условията на текущата криза",
  calc_cta_btn: "ЗАПОЧНЕТЕ ДА ПЕЧЕЛИТЕ",

  // Analysts
  analysts_badge: "НАШИЯТ ЕКИП",
  analysts_title: "Експерти с",
  analysts_title_accent: "ексклузивен достъп",
  analysts_subtitle: "Тези специалисти ви предоставят достъп до най-добрите нефтени договори и ви водят към максимална печалба.",
  analyst_contact: "СВЪРЖЕТЕ СЕ С",

  // Analyst names & descriptions
  analyst1_name: "Николай Илиев",
  analyst1_role: "Главен финансов анализатор",
  analyst1_desc: "Николай е водещ експерт в областта на петролните инвестиции с над 15 години опит. Специализира в анализ на геополитически рискове и тяхното влияние върху цените на суровия петрол.",
  analyst1_exp: "15+ години опит",
  analyst1_clients: "300+ клиенти",

  analyst2_name: "Димитър Стоянов",
  analyst2_role: "Старши анализатор на петролни пазари",
  analyst2_desc: "Димитър е специалист в техническия анализ на петролните пазари. Разработва стратегии за максимизиране на доходността при волатилни пазарни условия.",
  analyst2_exp: "12+ години опит",
  analyst2_clients: "250+ клиенти",

  analyst3_name: "Иван Стоянов",
  analyst3_role: "Анализатор на енергийни пазари",
  analyst3_desc: "Иван Стоянов фокусира своята дейност върху анализа на глобалните енергийни пазари. Специализира в идентифициране на инвестиционни възможности при кризисни ситуации.",
  analyst3_exp: "10+ години опит",
  analyst3_clients: "200+ клиенти",

  analyst4_name: "Миглена Станева",
  analyst4_role: "Финансов консултант",
  analyst4_desc: "Миглена е сертифициран финансов консултант с богат опит в управлението на инвестиционни портфейли. Предоставя персонализирани стратегии за всеки клиент.",
  analyst4_exp: "8+ години опит",
  analyst4_clients: "180+ клиенти",

  analyst5_name: "Николас Станев",
  analyst5_role: "Анализатор на суровини",
  analyst5_desc: "Николас Станев е специалист в анализа на суровинните пазари с фокус върху петрола и природния газ. Разработва прецизни прогнози за движението на цените.",
  analyst5_exp: "11+ години опит",
  analyst5_clients: "220+ клиенти",

  analyst6_name: "Стефан Минчев",
  analyst6_role: "Инвестиционен стратег",
  analyst6_desc: "Стефан Минчев е опитен инвестиционен стратег, специализиран в петролния сектор. Помага на клиентите да постигнат максимална доходност чрез оптимизирани инвестиционни стратегии.",
  analyst6_exp: "9+ години опит",
  analyst6_clients: "190+ клиенти",

  // Benefits
  benefits_title: "ЗАЩО НИ ИЗБИРАТ",
  benefits_subtitle: "Предимства на инвестирането в петролни договори Brent",
  benefit1_title: "Висока доходност",
  benefit1_desc: "Получавайте от 100% до 210% печалба благодарение на текущата геополитическа ситуация и ръста на цените на петрола",
  benefit2_title: "Сигурност",
  benefit2_desc: "Всички транзакции са защитени, договорите са юридически оформени, вашите инвестиции са под надеждна защита",
  benefit3_title: "Експертна подкрепа",
  benefit3_desc: "Екип от 6 сертифицирани финансови анализатори с многогодишен опит на петролния пазар",
  benefit4_title: "Бърз старт",
  benefit4_desc: "Прост процес на регистрация и активиране на договора. Започнете да печелите още днес",
  benefit5_title: "Глобален пазар",
  benefit5_desc: "Достъп до международни петролни договори Brent на институционално ниво",
  benefit6_title: "Прозрачност",
  benefit6_desc: "Редовни отчети, анализи и пълна прозрачност на всички операции и резултати",

  // About
  about_map_title: "ОРМУЗКИЯТ ПРОТОК Е БЛОКИРАН",
  about_map_sub: "от световния петрол",
  about_title: "КРИЗАТА СЪЗДАВА ВЪЗМОЖНОСТИ",
  about_p1: "Конфликтът в Иран доведе до блокиране на Ормузкия проток - критичен маршрут, през който преминава 20% от световните доставки на петрол.",
  about_p2: "Това предизвика рязък ръст на цените на петрола Brent, създавайки уникална възможност за инвеститорите да реализират значителна печалба чрез специализирани петролни договори.",
  about_p3: "Геополитическата нестабилност продължава да влияе на пазара и експертите прогнозират по-нататъшен ръст на цените през следващите месеци.",
  about_cta: "НАУЧЕТЕ СТРАТЕГИЯТА",

  // Contact
  contact_title: "ГОТОВИ ДА ЗАПОЧНЕТЕ?",
  contact_subtitle: "Свържете се с Николай Илиев и започнете своя инвестиционен път днес. Ограничен брой места за нови инвеститори.",
  contact_website: "Официален уебсайт",
  contact_hours: "Работно време",
  contact_hours_weekdays: "Понеделник – Петък: 9:00 – 18:00",
  contact_hours_saturday: "Събота: 10:00 – 14:00",
  contact_security: "Сигурност и доверие",
  contact_security_desc: "Всички транзакции са защитени и поверителни",
  contact_team_title: "Изберете своя анализатор",
  contact_team_sub: "6 лицензирани финансови специалисти",
  contact_team_desc: "Запознайте се с нашия екип от експерти и изберете анализатора, с когото искате да работите. Всеки от тях предлага персонален подход и пряк достъп до петролните договори Brent.",
  contact_btn: "СВЪРЖЕТЕ СЕ С НИКОЛАЙ ИЛИЕВ",
  contact_btn_sub: "Главен финансов анализатор с 15+ години опит",
  contact_choose_analyst_btn: "ИЗБЕРЕТЕ СВОЯ АНАЛИЗАТОР",
  contact_choose_analyst_sub: "6 лицензирани специалисти — намерете своя личен експерт",
  contact_stat_analysts: "Анализатори",
  contact_stat_clients: "Клиенти",
  contact_stat_yield: "Макс. доходност",

  // Footer
  footer_tagline: "Не пропускайте възможността да се възползвате от текущата пазарна ситуация.",
  footer_nav: "НАВИГАЦИЯ",
  footer_social: "СВЪРЖЕТЕ СЕ",
  footer_contact: "КОНТАКТ",
  footer_contact_desc: "За допълнителна информация и директна връзка с Николай Илиев:",
  footer_rights: "© 2026 Brent Oil Investment. Всички права запазени.",
  footer_terms: "Условия за ползване",
  footer_privacy: "Поверителност",
  footer_disclaimer: "Инвестициите в петролни договори носят риск. Миналите резултати не гарантират бъдеща печалба. Моля, инвестирайте отговорно.",
};

export default translation;
